<template>
  <base-layout>
    <content-section :spacing="false">
      <div class="content-spacing">
        <div class="grid grid-cols-1 mb-10 md:grid-cols-2">
          <div>
            <TitlePlus title="IOT Management" :hide-plus="true" />
          </div>
          <div class="flex md:justify-end">
            <date-range-picker
              @apply-date="onApplyFilterDateRange"
              @cancel-date="onApplyFilterDateRange"
            />
          </div>
        </div>
        <div class="summary-card-container">
          <SummaryCard
            title="Number of Locks"
            :value="indexMetaData.count.total"
            variant="gray"
            size="large"
          />

          <SummaryCard
            title="Assigned Locks"
            :value="indexMetaData.summary.assigned"
            variant="gray"
            size="large"
          />
          <SummaryCard
            title="Unassigned Locks"
            :value="indexMetaData.summary.unassigned"
            variant="gray"
            size="large"
          />
          <SummaryCard
            title="Damaged Locks"
            :value="indexMetaData.summary.damaged"
            variant="gray"
            size="large"
          />
        </div>
      </div>

      <FSTable
        :fst-id="fstId"
        :headers="getTableHeaders"
        :endpoint="endpoint"
        @meta="(e) => (indexMetaData = e)"
      >
        <template #default="{ data }">
          <template v-for="(item, itemIndex) in data">
            <template v-if="getTableMode === 'full'">
              <FSTableRow :key="itemIndex" text-fallback-always>
                <FSTableRowItem :text="item.id" :truncate="-5" />
                <FSTableRowItem
                  :to="{
                    name: 'ViewVehicleProfile',
                    params: { id: item.vehicle_id },
                  }"
                  :text="item.name"
                />
                <FSTableRowItem :text="item.vehicle_id" />
                <FSTableRowItem>
                  <battery-status :level="item.power_level" />
                </FSTableRowItem>
                <FSTableRowItem :text="item.lock_id" />
                <FSTableRowItem :text="item.sim_number" />
                <FSTableRowItem>
                  <div class="pl-10">
                    <i
                      :class="[
                        item.is_operational
                          ? 'fas fa-exclamation-circle text-red-500'
                          : 'fas fa-check-circle text-green-500',
                      ]"
                    />
                  </div>
                </FSTableRowItem>
                <FSTableRowItem>
                  <x-status
                    :variant="item.is_locked ? 'green' : 'orange'"
                    :text="item.is_locked ? 'Locked' : 'Unlocked'"
                    profile="trip"
                  />
                </FSTableRowItem>
              </FSTableRow>
            </template>
            <template v-if="getTableMode === 'responsive'">
              <FSTableRow :key="`fs-table-row-${itemIndex}`" textFallbackAlways>
                <FSTableRowItem>
                  <div
                    class="col-span-1 focus:text-gray-400"
                    @click="toggle(itemIndex)"
                  >
                    <i
                      class="fas fa-minus-circle"
                      style="color:#d90a20;"
                      v-if="opened.includes(itemIndex)"
                    ></i>
                    <i class="fas fa-plus-circle" v-else></i>
                  </div>
                </FSTableRowItem>
                <FSTableRowItem
                  :to="{
                    name: 'ViewVehicleProfile',
                    params: { id: item.vehicle_id },
                  }"
                  :text="item.name"
                />

                <FSTableRowItem>
                  <div class="pl-10">
                    <i
                      :class="[
                        item.is_operational
                          ? 'fas fa-exclamation-circle text-red-500'
                          : 'fas fa-check-circle text-green-500',
                      ]"
                    />
                  </div>
                </FSTableRowItem>
                <FSTableRowItem>
                  <x-status
                    :variant="item.is_locked ? 'green' : 'orange'"
                    :text="item.is_locked ? 'Locked' : 'Unlocked'"
                    profile="trip"
                  />
                </FSTableRowItem>
              </FSTableRow>
              <FSTableRow v-if="opened.includes(itemIndex)" :key="itemIndex">
                <td colspan="10">
                  <div
                    class="grid grid-cols-10 items-center w-full expand-item"
                  >
                    <div class="col-span-5 left-text">Id</div>
                    <div class="col-span-5 right-text">
                      {{ item.id | onlyLastFive }}
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-10 items-center w-full expand-item"
                  >
                    <div class="col-span-5 left-text">Assigned Vehicle</div>
                    <div class="col-span-5 right-text">
                      {{ item.vehicle_id }}
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-10 items-center w-full expand-item"
                  >
                    <div class="col-span-5 left-text">Battery Charge</div>
                    <div class="col-span-5 right-text">
                      <battery-status :level="item.power_level" />
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-10 items-center w-full expand-item"
                  >
                    <div class="col-span-5 left-text">IMEI Code</div>
                    <div class="col-span-5 right-text">{{ item.lock_id }}</div>
                  </div>
                  <div
                    class="grid grid-cols-10 items-center w-full expand-item"
                  >
                    <div class="col-span-5 left-text">SIM Number</div>
                    <div class="col-span-5 right-text">
                      {{ item.sim_number }}
                    </div>
                  </div>
                </td>
              </FSTableRow>
            </template>
          </template>
        </template>
      </FSTable>
    </content-section>
  </base-layout>
</template>
<script>
import BaseLayout from '@/views/shared/BaseLayout'
import ContentSection from '@/components/layout/ContentSection'
import TitlePlus from '@/components/ui/TitlePlus'
import {
  FSTable,
  FSTableRow,
  FSTableRowItem,
  onApplyFilterDateRange,
} from '@/components/fs-table'
import DateRangePicker from '@/components/picker/date-range/DateRangePicker'
import { LockConfig } from '@/config/LockConfig'
import SummaryCard from '@/components/cards/SummaryCard'
import BatteryStatus from '@/components/badge/BatteryStatus'
import XStatus from '@/components/badge/XStatus'
export default {
  name: 'IotManagementIndex',
  props: {
    fstId: {
      type: String,
      default: 'iot-management-index',
      required: false,
    },
    endpoint: {
      type: String,
      default: LockConfig.api.index,
      required: false,
    },
  },
  components: {
    BaseLayout,
    ContentSection,
    TitlePlus,
    FSTable,
    FSTableRow,
    FSTableRowItem,
    DateRangePicker,
    SummaryCard,
    BatteryStatus,
    XStatus,
  },

  data() {
    return {
      indexMetaData: {
        summary: {
          assigned: 0,
          unassigned: 0,
          damaged: 0,
        },
        count: {
          total: 0,
        },
      },
      windowWidth: window.innerWidth,
      opened: [],
      tableHeaders: [
        {
          text: 'Id',
          width: '10%',
          sort: 'id',
        },

        {
          text: 'IOT Name',
          width: '10%',
          sort: 'name',
        },

        {
          text: 'Assigned Vehicle',
          width: '15%',
          sort: 'vehicle_id',
        },

        {
          text: 'Battery Charge',
          width: '10%',
          sort: 'power_level',
        },
        {
          text: 'IMEI Code',
          width: '15%',
          sort: 'qr_code',
        },
        {
          text: 'SIM Number',
          width: '10%',
          sort: null,
        },
        {
          text: 'Operational',
          width: '10%',
          sort: 'is_operational',
        },
        {
          text: 'Lock Status',
          width: '10%',
          sort: 'is_locked',
        },
      ],
      resTableHeaders: [
        { text: '', width: '10%', sort: null },
        {
          text: 'IOT Name',
          width: '30%',
          sort: 'name',
        },
        {
          text: 'Operational',
          width: '10%',
          sort: 'is_operational',
        },
        {
          text: 'Lock Status',
          width: '25%',
          sort: 'is_locked',
        },
      ],
    }
  },

  computed: {
    getTableHeaders() {
      if (this.windowWidth <= 930) {
        return this.resTableHeaders
      } else {
        return this.tableHeaders
      }
    },
    getTableMode() {
      if (this.windowWidth <= 930) {
        return 'responsive'
      } else {
        return 'full'
      }
    },
  },
  methods: {
    onApplyFilterDateRange,
    onResize() {
      this.windowWidth = window.innerWidth
    },
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>
<style lang="scss" scoped>
.left-text {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3a4048;
}
.right-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6d6d75;
}
</style>
